<template>
  <v-card max-width="300" class="mx-auto fill-height">
    <v-row no-gutters dense align="center">
      <v-col cols="12">
        <router-link :to="logoRoute"><v-img contain height="78px" :src="uiConf.logoPath"></v-img></router-link>
      </v-col>
    </v-row>
    <v-divider class="grey mt-4"></v-divider>
    <sys-user-card v-if="isAuthenticated" />
    <v-divider class="grey mt-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-list nav dense
                v-for="(item) in items"
                :key="item.itemType"
        >
          <v-subheader>{{item.actionType}}</v-subheader>
          <v-list-item-group>
            <v-list-item
              v-for="(litem) in item.actions"
              :key="litem.action"
              @click="callFn(litem)"
            >
              <v-list-item-icon>
                <v-icon v-text="litem.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="litem.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { UI_INVOKE_ACTION, UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'sysNavPanel',
  props: ['mini', 'showMinify'],
  components: {
    SysUserCard: () => import(/* webpackChunkName: "commonUI" */ '@/components/common/ui/userSmallCard.vue')
  },
  data: () => ({
  }),
  mounted: function () {
    console.log('sysNavPanel mounted')
  },
  watch: {
  },
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated
    },
    items: function () {
      const userMenu = this.$store.getters.getCurrentActions
      return userMenu
    },
    logoRoute: {
      get: function () {
        return this.$store.getters.getDefaultPath
      }
    },
    uiConf: {
      get: function () {
        return this.$store.getters.getUIConf
      }
    }
  },
  methods: {
    callFn (item) {
      this.$store.dispatch(UI_INVOKE_ACTION, item)
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка:' + err })
        })
    }
  }
}
</script>
